<template>
  <div class="flex flex-col relative px-6">
    <ChatConversationStart :class="{ 'h-full': messages.length === 0 }" />
    <div
      class="space-y-6 pb-6"
      v-if="messages.length > 0"
    >
      <ChatMessage
        v-for="message in messages"
        :key="message.id"
        :message="message"
      />
      <ChatLoading v-if="isThinking" />
      <UProgress v-if="isAnswering && !isThinking" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ChatMessage from '@/components/chat/ChatMessage.vue'
import ChatLoading from '@/components/chat/ChatLoading.vue'
import UProgress from '@/components/ui/UProgress.vue'
import { storeToRefs } from 'pinia'
import { useConversationStore } from '@/stores/conversationStore'
import ChatConversationStart from './ChatConversationStart.vue'

const conversationStore = useConversationStore()
const { messages, isThinking, isAnswering } = storeToRefs(conversationStore)
</script>
